import { TextInputField } from './TextInputField';
import type { FormFieldComponent } from './types';
import { fieldRule, readFormField } from './useFormField';

const ROLE = 'genericInputField';
const FALLBACK_NAME = 'phoneNumber';

const GenericFormPhoneNumberInputField: FormFieldComponent = () => (
  <TextInputField role={ROLE} fallbackName={FALLBACK_NAME} type="tel" multiline={false} />
);

GenericFormPhoneNumberInputField.formSchema = content => fieldRule(readFormField(content, 'genericFields', ROLE), FALLBACK_NAME);

export default GenericFormPhoneNumberInputField;
